import { AlertColor } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import BoxContent from "../../components/boxContent";
import DataGridApi from "../../components/dataGridApi";
import QuickAlert from "../../components/form/quickAlert";
import MyModal from "../../components/MyModal";
import AddTerms from "../../components/terms/addTerms";
import EditTerms from "../../components/terms/editTerms";

export default function Terms() {
  const { t } = useTranslation();

  const [openModalAddTerms, setOpenModalAddTerms] = useState(false);

  const [openModalEditTerms, setOpenModalEditTerms] = useState(false);
  const [termsSelected, setTermsSelected] = useState<any>();

  const [visibleAlert, setVisibleAlert] = useState<boolean>(false);
  const [messageQuickAlert, setMessageQuickAlert] = useState("");
  const [severityAlert, setSeverityAlert] = useState<AlertColor>("success");
  const [titleMessage, setTitleMessage] = useState("");
  const [dataUpdated, setDataUpdated] = useState(0);

  const updateData = () => {
    const dataChange = dataUpdated + 1;
    setDataUpdated(dataChange);
  };

  const watchDataChange = (succesMessage?: string) => {
    const dataChange = dataUpdated + 1;
    setDataUpdated(dataChange);

    setVisibleAlert(true);
    setTimeout(() => {
      setVisibleAlert(false);
    }, 3000);

    setOpenModalAddTerms(false);
    setOpenModalEditTerms(false);
    setTitleMessage("Success");
    setMessageQuickAlert(succesMessage ? succesMessage : "");
    setSeverityAlert("success");
  };

  const messageError = (errorMessage?: string) => {
    setVisibleAlert(true);
    setTimeout(() => {
      setVisibleAlert(false);
    }, 3000);

    setTitleMessage("Error");
    setMessageQuickAlert(errorMessage ? errorMessage : "There was an error");
    setSeverityAlert("error");
  };

  const handleClickModaAddTerms = () => {
    setOpenModalAddTerms(true);
  };

  const editTerms = (e: any) => {
    setOpenModalEditTerms(true);
    console.log("e.row", e.row);
    // resetEdit();
    setTermsSelected(e.row);
  };

  const columns: GridColDef[] = [
    {
      field: "title",
      headerName: t("terms.title"),
      width: 729,
      headerClassName: "header-style",
    },
    {
      field: "active",
      headerName: "Status",
      width: 129,
      headerClassName: "header-style",
    },
  ];

  return (
    <BoxContent
      title={t("menu.terms")}
      button
      titleButton={t("terms.Add terms")}
      handleClick={handleClickModaAddTerms}
      noGlobal
    >
      <QuickAlert
        visibility={visibleAlert}
        description={messageQuickAlert}
        severity={severityAlert}
        title={titleMessage}
      />

      <DataGridApi
        onRowClick={editTerms}
        dataUpdated={dataUpdated}
        endPoint="termofuse/vwapp?"
        columnsData={columns}
        messageError={messageError}
      />

      {openModalAddTerms && (
        <MyModal
          title={t("terms.Add terms")}
          modalChange={setOpenModalAddTerms}
        >
          <AddTerms
            watchDataChange={watchDataChange}
            messageError={messageError}
          />
        </MyModal>
      )}

      {openModalEditTerms && (
        <MyModal
          title={t("terms.Edit terms")}
          modalChange={setOpenModalEditTerms}
        >
          <EditTerms
            watchDataChange={watchDataChange}
            messageError={messageError}
            data={termsSelected}
          />
        </MyModal>
      )}
    </BoxContent>
  );
}
